import React from "react";
import { Typography } from "@mui/material";
import Paycash from "../../../../../../../assets/Images/cash-on-delivery.png";
import Paycard from "../../../../../../../assets/Images/debit-card.png";
import buyoncredit from "../../../../../../../assets/Images/cash.png";
import { useBusinessTheme } from "src/shared/hooks/useBusinessTheme";
import { ModalWrapper } from "src/shared/components/ModalWrapper";

interface PaymentMethodDialogProps {
  open: boolean;
  onClose: () => void;
  onBack: () => void;
  onPaymentMethodSelect: (method: string) => void;
}

const PaymentMethodDialog: React.FC<PaymentMethodDialogProps> = ({ open, onClose, onBack, onPaymentMethodSelect }) => {
  const { loading } = useBusinessTheme();

  if (loading || !open) return null;

  return (
    <ModalWrapper title="Payment Confirmation" onClose={onClose} onBack={onBack} showBackButton showCloseButton width="max-w-lg">
      {/* Subtitle */}
      <Typography variant="subtitle1" textAlign="center" sx={{ mb: 2, fontSize: "1rem", fontWeight: 500 }}>
        Choose the payment option that fits your needs
      </Typography>

      {/* Payment Options - Using Tailwind CSS */}
      <div className="flex justify-around my-5">
        {/* Buy on Credit */}
        <div
          className="flex flex-col items-center p-5 border-2 border-gray-200 rounded-xl cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-lg hover:border-blue-500 hover:bg-blue-50 w-[120px]"
          onClick={() => onPaymentMethodSelect("Buy on credit")}
        >
          <img src={buyoncredit} alt="Buy on credit" className="w-[60px] h-[60px] mb-2.5" />
          <span className="text-sm text-gray-700 font-medium">Buy on credit</span>
        </div>

        {/* Card */}
        <div
          className="flex flex-col items-center p-5 border-2 border-gray-200 rounded-xl cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-lg hover:border-blue-500 hover:bg-blue-50 w-[120px]"
          onClick={() => onPaymentMethodSelect("Card")}
        >
          <img src={Paycard} alt="Card" className="w-[60px] h-[60px] mb-2.5" />
          <span className="text-sm text-gray-700 font-medium">Card</span>
        </div>

        {/* Cash */}
        <div
          className="flex flex-col items-center p-5 border-2 border-gray-200 rounded-xl cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-lg hover:border-blue-500 hover:bg-blue-50 w-[120px]"
          onClick={() => onPaymentMethodSelect("Cash")}
        >
          <img src={Paycash} alt="Cash" className="w-[60px] h-[60px] mb-2.5" />
          <span className="text-sm text-gray-700 font-medium">Cash</span>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default PaymentMethodDialog;
